import { OtherDocumentRepository } from "../domain/OtherDocumentRepository"
import { VueOtherDocumentScreenData } from "../infra/VueOtherDocumentScreenData"

export class OtherDocDetailComponent {
    
    document_repo:OtherDocumentRepository
    screen_data: VueOtherDocumentScreenData

    constructor(document_repo:OtherDocumentRepository, screen_data: VueOtherDocumentScreenData){
        this.document_repo = document_repo
        this.screen_data = screen_data
    }

    async get_document_url(id){
        let url = await this.document_repo.get_document_url(id)
        this.screen_data.setDocumentUrl(url)
    }

    async downloadFromUrl(o_url, filename){
        const res = await fetch(o_url)
        const blob = await res.blob();
        const url = await URL.createObjectURL(blob)
        const a = document.createElement("a");
        a.href = url;
        a.download =filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    async downloadPDF(id){
        if (!this.screen_data.document_url){
            await this.get_document_url(id)
        }
        let filename = this.screen_data.document['original_file_name']? this.screen_data.document['original_file_name'] : 'document.pdf'
        //replace extension
        filename = filename.replace(/\.[^/.]+$/, ".pdf");
        await this.downloadFromUrl(this.screen_data.document_url,filename)
    }
    async downloadCroppedPDF(id){
        let url = await this.document_repo.get_cropped_document_url(id)
        let filename = this.screen_data.document['original_file_name']? this.screen_data.document['original_file_name'] : 'document.pdf'
        //replace extension
        filename = "CROPPED_" + filename.replace(/\.[^/.]+$/, ".pdf");
        await this.downloadFromUrl(url, filename)
    }
    async downloadOriginalFile(id, original_file_name: string){
        let url = await this.document_repo.get_original_document_url(id)
        let filename = original_file_name? original_file_name : 'document.pdf'
        // no need to replace extension, we download the original file
        await this.downloadFromUrl(url, filename)
    }

    async find_by_id(id: any): Promise<any> {
        let document = await this.document_repo.find_by_id(id)
        if (document) {
            if (document.workflows.length > 0 && document.workflows[0].workflow_template) {
                let allStages = document.workflows[0].workflow_template.stages
                let currentStage = document.workflows[0].current_stage
                this.screen_data.setAllStages(allStages)
                this.screen_data.setCurrentStage(currentStage)
            }
            this.screen_data.setDocument(document)
            this.screen_data.refreshCounter += 1
            if (this.screen_data.companyFolders.length > 0) {
                this.screen_data.folderRoute = this.buildFolderRoute()
            }
        }

    }

    async aproveDocument(id: any): Promise<any> {
        this.screen_data.setLoadingAprove(true)
        await this.document_repo.aproveDocument(id)
        await this.find_by_id(id)
        this.screen_data.setLoadingAprove(false)
        this.auto_refresh_untill_stable()
    }

    async rejectDocument(id: any): Promise<any> {
        this.screen_data.setLoadingRejected(true)
        await this.document_repo.rejectDocument(id)
        await this.find_by_id(id)
        this.screen_data.setLoadingRejected(false)
    }

    async saveDocumentComments(id, comments): Promise<any> {
        this.screen_data.setLoadingSave(true)
        let args = { doc_id: id, comments: comments }
        await this.document_repo.saveDocumentComments(args)
        await this.find_by_id(id)
        this.screen_data.setLoadingSave(false)
        this.screen_data.setDirty(false)
    }

    async continueWorkflow(id:number) {
        this.screen_data.setLoadingContinue(true)
        await this.document_repo.callContinueWorkflow({ doc_id: id })
        await this.find_by_id(id)
        this.screen_data.setLoadingContinue(false)
        this.auto_refresh_untill_stable()
    }

    async retryWorkflow(id: number) {
        this.screen_data.setLoadingContinue(true);
        const doc = await this.document_repo.find_by_id(id);

        await this.document_repo.callRetryWorkflow({
            doc_id: id,
            wf_id: doc.workflows[0].id
        });

        this.screen_data.document['state'] = 'pending'
        this.screen_data.setLoadingContinue(false);
        this.auto_refresh_untill_stable();
    }

    am_in_stable_state(): boolean {
        let stable_states = ['done','error','rejected', 'waiting_approval','waiting']
        return stable_states.includes(this.screen_data.document['state'])
    }

    async auto_refresh_untill_stable(){
        if (this.screen_data && this.screen_data.document && this.screen_data.document['id'] != null && !this.am_in_stable_state()) {
            this.screen_data.setLoadingContinue(true)
            const id = this.screen_data.document['id']
            await this.find_by_id(id)
            setTimeout(() => {
                this.auto_refresh_untill_stable()
            }, 2000)
        }
        else {
            this.screen_data.setLoadingContinue(false)
        }

    }

    force_stop_auto_refresh() {
        this.screen_data.document = null // millorable pero per ara funciona
    }

    async getCompanyFolders(company_id) {
        let args = { company_id }
        let folder_map = await this.document_repo.getCompanyFolders(args)
        this.screen_data.companyFolders = [{'name':'Mi unidad','id':'Mi unidad', 'children': folder_map}]
    }

    userSelectsFolder() {
        this.screen_data.popUpSelectFolder = true;
        return new Promise((resolve) => {
            this.screen_data.resolveSelectedFolderPromise = resolve;
        });
    }

    confirmFolderPopUp(folder_uuid) {
        if (this.screen_data.resolveSelectedFolderPromise) {
            this.screen_data.resolveSelectedFolderPromise(folder_uuid);
            this.screen_data.resolveSelectedFolderPromise = null;
        }
    }

    cancelFolderPopUp() {
        this.screen_data.popUpSelectFolder = false;
        if (this.screen_data.resolveSelectedFolderPromise) {
            this.screen_data.resolveSelectedFolderPromise(null);
            this.screen_data.resolveSelectedFolderPromise = null;
        }
    }

    async moveDocToFolder(company_id) {
        await this.getCompanyFolders(company_id)
        let selected_folder = await this.userSelectsFolder();
        if (selected_folder == null) {
            return;
        }
        this.screen_data.loadingMoveFolder = true
        selected_folder = selected_folder == "Mi unidad" ? null : selected_folder
        let doc_id = this.screen_data.document['id']
        let args = { folder_uuid: selected_folder, doc_ids: [doc_id], company_id: company_id }
        await this.document_repo.moveDocsToFolder(args)
        await this.find_by_id(doc_id)
        this.screen_data.loadingMoveFolder = false
        this.screen_data.popUpSelectFolder = false;
    }

    buildFolderRoute() {
        let folder_uuid = this.screen_data.document ? this.screen_data.document['folder_uuid'] : null
        let filename = this.screen_data.document ? this.screen_data.document['original_file_name'] : null
        let folderPath = folder_uuid == null ? 'Mi unidad' : this.getFolderPath(this.screen_data.companyFolders, '', folder_uuid)
        if (!folderPath) folderPath = 'Mi unidad'
        return filename ? folderPath + '/' + filename : folderPath
    }

    getFolderPath(folders, so_far_route, folder_uuid) {
        for (let i = 0; i < folders.length; i++) {
            let folder = folders[i];
            if (folder.id == folder_uuid) {
                return so_far_route + folder.name;
            }
            if (folder.children) {
                let current_route = folder.name == 'Mi unidad' ? folder.name + '/' : so_far_route + folder.name + '/'
                let found_route = this.getFolderPath(folder.children, current_route, folder_uuid);
                if (found_route) {
                    return found_route;
                }
            }
        }
        return null
    }

}